import React from "react";
import { PropagateLoader } from "react-spinners";

const LoadingOverlay = ({ loading = true, color = "#233F93", size = 15, margin = 5 }) => {
  if (!loading) return null; // No mostrar si no está cargando

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-60">
      <PropagateLoader
        loading={loading}
        color={color}
        size={size}      // tamaño de cada círculo
        margin={margin}  // espacio entre círculos
      />
    </div>
  );
};

export default LoadingOverlay;
